import axios from 'axios';
import { useEffect, useState } from 'react';
import { app } from '../config';
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
let url = `${app.URL}/org/fetchall`;
const fetchUserallowedRoutes2 = (roleId) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const token=getTokenfromUserObj();
  useEffect(() => {
    const fetchRoutes = async (id) => {
      try {
        const res = await axios.get(`${app.URL}/roleperm/viewbyroleid2/${id}`,{headers:{auth:token}});
        console.log(res);
        let paths = [];
        if (res.data) {
          res.data.forEach((obj) => {
            paths.push({roleId:obj.role_id,module:obj.module,action:obj.action,is_render:obj.is_render,is_root:obj.is_root});
          });
        }

        setResponse(paths);

        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchRoutes(roleId);
  }, []);

  return { loading, response, error };
};

export default fetchUserallowedRoutes2;
